export enum DocumentTypesEnum {
	CreditNote = 'CreditNote',
	DebitNote = 'DebitNote',
	Invoice = 'Invoice',
}

export enum ApprovalStateEnum {
	Approved = 'Approved',
	NotApproved = 'NotApproved',
	PendingBuyerApproval = 'PendingBuyerApproval',
	PendingSupplierApproval = 'PendingSupplierApproval',
	Registered = 'Registered',
	Rejected = 'Rejected',
}

export enum PaymentStatesEnum {
	Advanced = 'Advanced',
	CreditAssignmentApproved = 'CreditAssignmentApproved',
	CreditAssignmentPending = 'CreditAssignmentPending',
	FundingPending = 'FundingPending',
	LockForTransaction = 'LockForTransaction',
	NotSubmitted = 'NotSubmitted',
	Paid = 'Paid',
	PaidExternally = 'PaidExternally',
	PaymentPending = 'PaymentPending',
	Unpaid = 'Unpaid',
}

export enum UploadDocumentsValidationCodesEnum {
	Invalid = 'Invalid',
	Valid = 'Valid',
}
